export class FilterFlags {
    salesFilters: boolean = false;
    operationsFilters: boolean = false;
    callFilters: boolean = false;
    reportCodeFilters: boolean = false;
    advancedFilters: boolean = false;
    salesAI: boolean = false;
    cxaiFilters: boolean = false;
    insight: boolean = false;
    aiFlaggedIssues: boolean = false;
    scorecardAnswer: boolean = false;
    qaScorecardFilter: boolean = false;
    qaFilters: boolean = false;
    customerSentimentFilters: boolean = false;
    agentSentimentFilters: boolean = false;
    customerFilters: boolean = false;
    complaintsFilters: boolean = false;
    qaComplaintsFilters: boolean = false;
    vulnerabilitiesFilters: boolean = false;
    gdprFilters: boolean = false;
    vocFilters: boolean = false;
    aiNoteFilters: boolean = false;
}